import Parse from '@/parse'
const Quiz = Parse.Object.extend('Quiz')

export default {
  initForm ({ state, commit }) {
    commit('setNumber', state.quiz.get('number'))
    commit('setCardNumber', state.quiz.get('card').get('number'))
    commit('setSuit', state.quiz.get('card').get('suit'))
    commit('setUrl', state.quiz.get('url'))
    commit('setName', state.quiz.get('name'))
    commit('setDescription', state.quiz.get('description'))
    commit('setHint', state.quiz.get('hint'))
    const location = state.quiz.get('location')
    if (location) {
      commit('setLat', location.latitude)
      commit('setLng', location.longitude)
    } else {
      commit('setLat', 0)
      commit('setLng', 0)
    }
    commit('setRadius', state.quiz.get('radius') * 1000)
  },

  async retrieveQuizzes ({ commit }, id) {
    let query = new Parse.Query(Quiz)
    query.equalTo('quizset', id)
    query.include('card')
    query.include('card.suit')
    query.ascending('number')
    const result = await query.find()
    commit('setQuizzes', result)
  },

  async getQuiz ({ commit }, id) {
    const query = new Parse.Query(Quiz)
    query.include('card')
    try {
      const quiz = await query.get(id)
      commit('setQuiz', quiz)
    } catch (error) {
      console.log(error)
    }
  },

  getSideQuizzes ({ state, commit }) {
    const number = state.quiz.get('number') - 1
    const quizzes = state.quizzes

    commit('setBackQuiz', quizzes[number - 1])
    commit('setNextQuiz', quizzes[number + 1])
  },

  saveQuiz ({ state }) {
    const params = {
      id: state.quiz.id,
      number: state.number,
      cardNumber: state.cardNumber,
      suit: state.suit.id,
      url: state.url,
      name: state.name,
      description: state.description,
      hint: state.hint,
      lat: state.lat,
      lng: state.lng,
      radius: parseFloat(state.radius) / 1000
    }

    return Parse.Cloud.run('updateQuiz', params)
  },

  deleteQuiz ({ state, commit }) {
    state.quiz.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        'クイズセットを削除しました。',
        { root: true }
      )
    })
  },

  async shuffleQuiz ({ commit, dispatch }, id) {
    const result = await Parse.Cloud.run('shuffleQuiz', { id: id })
    const reload = () => {
      dispatch('retrieveQuizzes', id)
    }

    setTimeout(reload, 1000)
    commit(
      'snackBar/addMessage',
      result,
      { root: true }
    )
  }
}
